const JWT_COOKIE_NAME = 'jwtToken';
const JT_COOKIE_NAME = 'jtToken';
const X_API_KEY_COOKIE_NAME = 'xApiKey';

const setCookie = (name: string, value: string) => {
  const expires = new Date(Date.now() + 1 * 864e5).toUTCString();
  document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; Secure; SameSite=Strict`;
  // const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  // if (isLocalhost) {
  //   /* localhost */
  //   document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`
  // } else {
  //   /* non-localhost: use domain and secure */
  //   document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/; domain=.jobtarget.com; Secure; SameSite=None`
  // }
};

const getCookie = (name: string): string => {
  const match = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
  return match ? decodeURIComponent(match.pop() || '') : '';
};

export const setJwtToken = async (token: string) => {
  await setCookie(JWT_COOKIE_NAME, token);
};

export const setJtToken = async(token: string) => {
  await setCookie(JT_COOKIE_NAME, token)
}

export const getJwtToken = (): string => {
  const cookie = getCookie(JT_COOKIE_NAME) || getCookie(JWT_COOKIE_NAME);
  return cookie;
};

export const setXApiKey = (token: string) => {
  setCookie(X_API_KEY_COOKIE_NAME, token);
};

export const getXApiKey = (): string => {
  return getCookie(X_API_KEY_COOKIE_NAME);
};
